/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Vikas Kumar Portfolio",
  description:
    "Meet Vikas Kumar, an experienced software engineer with years of expertise in developing, maintaining, and deploying applications. With a strong skill set in programming languages including .NET Core, Java, C++, and C, Vikas Kumar has a proven ability to work with cross-functional teams to deliver high-quality solutions. Vikas Kumar's dedication to staying up-to-date with the latest technologies and industry trends has allowed them to develop efficient and innovative solutions for a variety of projects. Whether working independently or as part of a team, Vikas Kumar consistently exceeds expectations and delivers exceptional results.",
  og: {
    title: "Vikas Kumar Portfolio",
    type: "website",
    url: "https://vikaspandey121.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Vikas Kumar",
  logo_name: "VikasPandey",
  nickname: "VikasPandey121",
  subTitle:
    "Meet Vikas Kumar, an experienced software engineer with years of expertise in developing, maintaining, and deploying applications. With a strong skill set in programming languages including .NET Core, Java, C++, and C, Vikas Kumar has a proven ability to work with cross-functional teams to deliver high-quality solutions. Vikas Kumar's dedication to staying up-to-date with the latest technologies and industry trends has allowed them to develop efficient and innovative solutions for a variety of projects. Whether working independently or as part of a team, Vikas Kumar consistently exceeds expectations and delivers exceptional results.",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KBx8TcD/view?usp=sharing",
  portfolio_repository: "https://github.com/VikasPandey121/VikasPandey121.github.io",
  githubProfile: "https://github.com/VikasPandey121",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/VikasPandey121",
  // linkedin: "https://www.linkedin.com/in/VikasPandey121/",
  // gmail: "VikasPandey98@gmail.com",
  // gitlab: "https://gitlab.com/VikasPandey98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/VikasPandey121",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/VikasPandey121/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCEdTQwKaeAOL5pUgdN-zJQQ",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:12.vikaskumar99@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/VikasPandey827",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/VikasPandey827/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/VikasPandey121/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Backend Developer",
      fileName: "FullStackImg",
      skills: [
        "⚡ Proficient in developing and implementing backend solutions using .NET Core, Java, C++, and C programming languages",
        "⚡ Skilled in creating RESTful APIs, integrating with databases, and deploying applications to production environments",
        "⚡ Experienced in collaborating with cross-functional teams to develop, test, and maintain software solutions that meet business requirements and ensure high performance and scalability.",
      ],
      softwareSkills: [
        {
          skillName: ".NET Core",
          fontAwesomeClassname: "mdi:dot-net",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "skill-icons:java-dark",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Oracle SQL",
          fontAwesomeClassname: "logos:oracle",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "vscode-icons:file-type-cpp3",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "vscode-icons:file-type-c",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Bash Script",
          fontAwesomeClassname: "logos:bash",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "mdi:git",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Tuxedo",
          fontAwesomeClassname: "vscode-icons:folder-type-middleware",
          style: {
            color: "#663399",
          },
        },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/VikasPandey121/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/VikasPandey121",
    },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Netaji Subhas University of Technology (West Campus)",
      subtitle: "B.Tech. in Information Technology",
      logo_path: "NSUT_logo.png",
      alt_name: "NSUT West-Campus",
      duration: "2018 - 2022",
      descriptions: [
        "⚡ In-depth understanding of core computer science concepts including data structures, algorithms, computer networks, and operating systems.",
        "⚡ Proficiency in various programming languages such as Java, C#, C and C++ with hands-on experience in developing software applications using industry-standard tools and frameworks.",
        "⚡ Strong problem-solving and analytical skills acquired through coursework, projects, and internships, which enable you to design and develop innovative solutions for real-world challenges.",
      ],
      website_link: "http://www.nsut.ac.in/",
    },
    // {
    //   title: "Indiana University Bloomington",
    //   subtitle: "M.S. in Computer Science",
    //   logo_path: "iu_logo.png",
    //   alt_name: "Indiana University Bloomington",
    //   duration: "2021 - 2023",
    //   descriptions: [
    //     "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
    //     "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
    //     "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
    //   ],
    //   website_link: "https://www.indiana.edu/",
    // },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Git",
      subtitle: "- Jason Taylor",
      logo_path: "Udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-FG15JYSP/",
      alt_name: "Udemy",
      color_code: "#8C151599",
    },
    {
      title: "AWS Cloud Practitioner Certification",
      subtitle: "- AWS",
      logo_path: "AWS_logo.png",
      certificate_link:
        "https://www.credly.com/badges/bf204c18-802f-46c1-8d1b-a70b6fde58dc",
      alt_name: "Amazon Web Services",
      color_code: "#00000099",
    },
    {
      title: "Azzure Ninja",
      subtitle: "- Microsoft",
      logo_path: "Microsoft_Azure_Logo.png",
      certificate_link:
        "https://www.credential.net/115100f5-a1cc-4e90-b645-6309ad3f9c85#gs.7fvixw",
      alt_name: "Microsoft Azure",
      color_code: "#0C9D5899",
    },
    {
      title: "Communication Strategies",
      subtitle: "- Ivan Wanis Ruiz",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/6BTP2N7Y4QNY",
      alt_name: "Coursera",
      color_code: "#1F70C199",
    },
    {
      title: "Robotics",
      subtitle: "- Second Position",
      logo_path: "NSUT_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1cZHMPX9VszI-3IQw8-gd_yqqEqPqTpmy/view",
      alt_name: "NSUT West-Campus",
      color_code: "#D83B0199",
    },
    {
      title: "HackGec",
      subtitle: "- Third Position",
      logo_path: "NSUT_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1l6NDEMaiaPU6ckmMIknD_Emi65oYliC0/view?usp=sharing",
      alt_name: "NSUT West-Campus",
      color_code: "#1F70C199",
    },
    {
      title: "Docker Essential Training: 1 Installation and Configuration",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/bfbad8abe65271009522d063329236378406fcf55617045269ac3286aa955634",
      alt_name: "LinkedIn",
      color_code: "#FFFFFF",
    },
    {
      title: "Docker Essential Training: 2 Orchestration",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/5d9cb6da37f6b374e9841dada0e17498d3f2d7ac3d806b56a550c776c18336e5",
      alt_name: "LinkedIn",
      color_code: "#FFFFFF",
    },
    {
      title: "Introducing .NET Core",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/b27acf005c10180744b4253cea69fdc8c9bc07d8bcfca097e3b07f5bd53e3cd4",
      alt_name: "LinkedIn",
      color_code: "#FFFFFF",
    },
    {
      title: "Learning Docker",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/3171f566ba5bf2d56168cf26c1d2d91a60d08f291c92cf45092c2962131f13ce",
      alt_name: "LinkedIn",
      color_code: "#FFFFFF",
    },
    {
      title: "DevOps Foundations",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/11744c838757fc203cf0f45cd52bb1d32ba5615394ca366f933177ebedfb2579",
      alt_name: "LinkedinLearning",
      color_code: "#FFFFFF",
    },
    {
      title: "DevOps Foundations: CI/CD",
      subtitle: "- LinkedIn",
      logo_path: "LinkedIn_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/bc3f99354d697a129c8d67916706cd9af3538346af192fcaf8c9c1cea0a73c14",
      alt_name: "GCP",
      color_code: "#FFFFFF",
    },
    // {
    //   title: "DevOps Foundations: DevSecOps",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "LinkedinLearning",
    //   certificate_link:
    //     "https://www.linkedin.com/learning/certificates/66941fd5f8b539a7b5ce526c354e17bdb2e69eda75fdcb5e4b26e6674e1bb93e",
    //   alt_name: "LinkedinLearning",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Microsoft Week of AI 2.0",
    //   subtitle: "- Microsoft",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://www.credential.net/115100f5-a1cc-4e90-b645-6309ad3f9c85",
    //   alt_name: "Microsoft",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "DevOps Foundations: Continuous Delivery/Continuous Integration",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://www.linkedin.com/learning/certificates/bc3f99354d697a129c8d67916706cd9af3538346af192fcaf8c9c1cea0a73c14",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "DevOps Foundations: Continuous Delivery/Continuous Integration",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://www.linkedin.com/learning/certificates/bc3f99354d697a129c8d67916706cd9af3538346af192fcaf8c9c1cea0a73c14",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "Vikas Kumar, a highly motivated individual who has made valuable contributions to various open-source organizations and volunteered for multiple NGOs and companies. With a passion for technology and a desire to make a positive impact on society, Vikas Kumar has been actively involved in developing and supporting open-source software projects that benefit the community. In addition to contributing to the open-source community, Vikas Kumar has also volunteered for several NGOs and companies, dedicating time and effort towards causes such as education, healthcare, and environmental sustainability. Currently, Vikas Kumar is a valued member of the Amdocs team, having joined the company in July 2022. With a diverse set of skills and a strong work ethic, Vikas Kumar is committed to delivering high-quality solutions that exceed expectations and drive business success.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Associate Software Engineer",
          company: "Amdocs",
          company_url: "https://www.amdocs.com/",
          logo_path: "amdocs_logo.jpg",
          duration: "July 2022 - Present",
          location: "Gurugram, India",
          description:
            "Vikas Kumar is a valued member of the Amdocs team, having joined the company in July 2022. With a diverse set of skills and a strong work ethic, Vikas Kumar is committed to delivering high-quality solutions that exceed expectations and drive business success.",
          color: "#0879bf",
        },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Alexa Student Influencer",
          company: "Amazon Alexa",
          company_url: "https://developer.amazon.com/en-US/alexa",
          logo_path: "Alexa_Logo.png",
          duration: "June 2019 - April 2020",
          location: "Delhi, India",
          description:
            "The Alexa Student Influencers Program is a campus connect program that aims to form a network of like-minded students across India. Alexa Student Influencers (ASI) are young campus ambassadors and leaders passionate to learn new technologies in Artificial Intelligence and Voice Technologies, and enthusiastic to share their learnings with fellow colleagues. ASIs will act as the primary conduit between campus students and Amazon Alexa team.",
          color: "#000000",
        },
        {
          title: "Head of Progection Community",
          company: "ProGection",
          company_url: "https://progection.github.io/",
          logo_path: "progection_logo.png",
          duration: "Jan 2020 - June 2022",
          location: "Delhi, India",
          description:
            "ProGection Technical Club is an initiative to grow their knowledge on developer technologies and more through peer to peer workshops and events, and gain relevant industry experience. My responsibility for this program is to create opensource environment in college. We have organised multiple hackathons on the problems collected by ordinary people from New Delhi city. We have build opensource community of our own college. The community is available at ProGection on github.",
          color: "#ee3c26",
        },
        {
          title: "Project Admin",
          company: "Girlscript",
          company_url:
            "https://gwoc.girlscript.tech/",
          logo_path: "GirlScript_logo.png",
          duration: "Aug 2021 - July 2022",
          location: "Work From Home",
          description:
            "As the responsible party, I oversaw the content monitoring process and merged the final content into the main repository. Before merging, I meticulously checked for any instances of plagiarism. Additionally, I reviewed and merged each pull request personally.",
          color: "#0071C5",
        },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Medium articles",
  description:
    "I have written many Medium articles related to technical understanding of Git, Android and many more.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "How to install openVINO on ubuntu 18.04?",
      createdAt: "2020-02-06T16:26:54Z",
      description: "It provides a step-by-step guide on how to install openVINO on Ubuntu 18.04.",
      url:
        "https://medium.com/coding-blocks/how-to-install-openvino-on-ubuntu-18-04-e8d7d2dc1a8e",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "How to create OnBoarding Screen within three minutes?",
      createdAt: "2020-07-06T16:26:54Z",
      description: "I have outlined a quick and easy way to create an onboarding screen in just three minutes.",
      url:
        "https://vikaspandey121.medium.com/how-to-create-onboarding-screen-within-three-minutes-e5b159189faf",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "How to use Firebase Phone and Google Authentication in Android.",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Read to understand authentication using different platforms on Android applications. ",
      url:
        "https://vikaspandey121.medium.com/how-to-use-firebase-phone-and-google-authentication-in-android-2581c97e6592",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Professional Ethics for contributing to open-source",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Follow mentioned guidlince for easy and effective open-source contributions.",
      url:
        "https://medium.com/coding-blocks/professional-ethics-for-contributing-to-open-source-f1178571e839",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "How to create Alexa skill",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Step by step intruction to kickstart journey with voice assistance platform Amazon Alexa.",
      url:
        "https://vikaspandey121.medium.com/how-to-create-alexa-skill-9d1f6839c3ac",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "VikasPandey121.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with REST API, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.VikasPandey.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Saket, New-Delhi, Delhi - 110080",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/VPDRjcrWvVJMxJv56",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9315973945",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
